import React from 'react';
import './workflowEditor.css';
import { Button } from 'react-bootstrap';

export const PromotionButtons = ({ data, onTestingLinkClicked, onPromoteToProduction, editable }) => {
  if (editable && data && (!data?.isTested || data?.status !== 'active')) {
    return (
      <>
        <Button variant="primary" width={200} onClick={() => onTestingLinkClicked(data)} size="sm">
          Test Now
        </Button>
        {data.isTested ? (
          <Button variant="primary" width={200} onClick={() => onPromoteToProduction(data)} size="sm" className="ml-2">
            Promote to Production
          </Button>
        ) : null}
      </>
    );
  }
  return null;
};
